import { Box, Typography, Link as JoyLink } from '@mui/joy';
import { useNavigate } from 'react-router';
import { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { ATSConnection } from './index';
import { getProvider } from './providers';
import { getProviderQueries } from './providerQueryMap';
import useUser from '../auth/useUser';
import LargeLoader from '../LargeLoader';

const ATSConnectPage = () => {
  const navigate = useNavigate();
  const { user, loading: userLoading } = useUser();
  const providerId = user?.client?.selectedATSProvider;
  const provider = providerId ? getProvider(providerId) : null;
  const pq = providerId ? getProviderQueries(providerId) : null;

  const { data: statusData, loading: statusLoading } = useQuery(pq?.GET_STATUS, {
    skip: !pq,
    fetchPolicy: 'network-only',
  });

  // Guard: no provider selected → back to jobs
  useEffect(() => {
    if (!userLoading && !providerId) {
      navigate('/jobs');
    }
  }, [userLoading, providerId, navigate]);

  // Auto-advance when connected
  useEffect(() => {
    if (!statusData || !pq) return;
    const status = statusData[pq.statusField];
    if (status?.enabled) {
      navigate('/onboarding/import-job');
    }
  }, [statusData, pq, navigate]);

  if (userLoading || statusLoading) return <LargeLoader />;
  if (!provider) return null;

  return (
    <Box
      sx={{
        py: 4,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        width: '100%',
        maxWidth: 'sm',
        mx: 'auto',
      }}
    >
      <Box sx={{ mb: 1 }}>
        <Typography level="h4" gutterBottom>Connect your {provider.name} account</Typography>
        <Typography level="body-sm" color="neutral">
          Link {provider.name} to import jobs and candidates automatically.
        </Typography>
      </Box>

      <ATSConnection providerId={providerId} />

      <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
        <JoyLink
          level="body-sm"
          color="neutral"
          component="button"
          onClick={() => navigate('/jobs')}
        >
          Skip for now
        </JoyLink>
      </Box>
    </Box>
  );
};

export default ATSConnectPage;
